module.exports = __webpack_public_path__ + "img/ai.96ae259d.svg";